import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { isSameQuarter, formatValue } from '../../utils/dateUtil';
import RangeContext from '../../RangeContext';
import useCellClassName from '../../hooks/useCellClassName';
import PanelBody from '../PanelBody';
import moment from 'moment';
export var QUARTER_COL_COUNT = 2;
var QUARTER_ROW_COUNT = 1;

function HalfYearBody(props) {
  var prefixCls = props.prefixCls,
      locale = props.locale,
      value = props.value,
      viewDate = props.viewDate,
      generateConfig = props.generateConfig;

  var _React$useContext = React.useContext(RangeContext),
      rangedValue = _React$useContext.rangedValue,
      hoverRangedValue = _React$useContext.hoverRangedValue;

  var cellPrefixCls = "".concat(prefixCls, "-cell");
  var getCellClassName = useCellClassName({
    cellPrefixCls: cellPrefixCls,
    value: value,
    generateConfig: generateConfig,
    rangedValue: rangedValue,
    hoverRangedValue: hoverRangedValue,
    isSameCell: function isSameCell(current, target) {
      return isSameQuarter(generateConfig, current, target, 'halfYear');
    },
    isInView: function isInView() {
      return true;
    },
    offsetCell: function offsetCell(date, offset) {
      return generateConfig.addMonth(date, offset * 6);
    }
  }); // default format

  var _format = function format(date) {
    var hasYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (moment.isMoment(date)) {
      var year = hasYear ? date.year() + ' ' : '';
      return date.month() >= 0 && date.month() <= 5 ? "".concat(year, "\u4E0A\u534A\u5E74") : "".concat(year, "\u4E0B\u534A\u5E74");
    }
  };

  var baseHalfYear = generateConfig.setDate(generateConfig.setMonth(viewDate, 0), 1);
  return /*#__PURE__*/React.createElement(PanelBody, _extends({}, props, {
    rowNum: QUARTER_ROW_COUNT,
    colNum: QUARTER_COL_COUNT,
    baseDate: baseHalfYear,
    getCellText: function getCellText(date) {
      return formatValue(date, {
        locale: locale,
        format: function format() {
          var _locale$halfYearForma;

          return ((_locale$halfYearForma = locale.halfYearFormat) === null || _locale$halfYearForma === void 0 ? void 0 : _locale$halfYearForma.call(locale, date, false)) || _format(date, false);
        },
        generateConfig: generateConfig
      });
    },
    getCellClassName: getCellClassName,
    getCellDate: function getCellDate(date, offset) {
      return generateConfig.addMonth(date, offset * 6);
    },
    titleCell: function titleCell(date) {
      return formatValue(date, {
        locale: locale,
        format: function format() {
          var _locale$halfYearForma2;

          return ((_locale$halfYearForma2 = locale.halfYearFormat) === null || _locale$halfYearForma2 === void 0 ? void 0 : _locale$halfYearForma2.call(locale, date)) || _format(date);
        },
        generateConfig: generateConfig
      });
    }
  }));
}

export default HalfYearBody;